import { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import RoundedButton from 'components/RoundedButton'
import Spacer from 'components/Spacer'

import { useUserListings } from 'services/swr/listings/useUserListings'

import { formatAddress } from 'utils/listingHelpers'

const Container = styled.div`
  padding: 100px 10px;
  background: ${props => props.theme.colors.grey2};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.colors.blue};
`

const TitleText = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 52px;
  line-height: 58px;
  color: ${props => props.theme.colors.white};
  text-align: center;
`

const SubtitleText = styled(TitleText)`
  font-size: 22px;
  line-height: 32px;
`

const ResumeListing = () => {
  const theme = useContext(ThemeContext)
  const { listings, error: listingsError } = useUserListings()

  if (!listings || !Array.isArray(listings)) return null

  const newestListing = listings?.sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
  )[0]

  if (!newestListing || listingsError) return null

  return (
    <Container>
      <TitleText>Resume Previous Listing</TitleText>
      <Spacer />
      <SubtitleText>{formatAddress(newestListing)}</SubtitleText>
      <Spacer />
      <RoundedButton
        text="Edit My Listing"
        href="/listing/[id]/create/welcome"
        as={`/listing/${newestListing._id}/create/welcome`}
        background={theme.colors.yellow}
        width={220}
      />
    </Container>
  )
}

export default ResumeListing
